import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Code.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "CodeIcon";
const n = e;
export {
  n as Code,
  e as CodeIcon
};
